module.exports = __webpack_public_path__ + "img/yezi1.4cbdea40.png";